import { createEntityAdapter } from "@reduxjs/toolkit";
import { ChatbotConversation } from "./types";

export const chatbotConversationAdaptor =
  createEntityAdapter<ChatbotConversation>({
    selectId: (e) => e.threadId,
    sortComparer: (a, b) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime(), // This is what decides the order of entites in the array
  });
